import { RootState, SpecialOfferReceiptState } from '@/types/store'
import { GetSpecialOfferReceiptResponse } from '../../../api/@types'
import { GetterTree } from 'vuex'

export interface SpecialOfferReceiptGetters
  extends GetterTree<SpecialOfferReceiptState, RootState> {
  specialOfferReceipt: (
    state: SpecialOfferReceiptState,
  ) => GetSpecialOfferReceiptResponse
  specialOfferReceipts: (
    state: SpecialOfferReceiptState,
  ) => GetSpecialOfferReceiptResponse[]
  nextReceiptId: (state: SpecialOfferReceiptState) => number | null
}

export const getters: SpecialOfferReceiptGetters = {
  specialOfferReceipt(state) {
    return state.specialOfferReceipt
  },
  specialOfferReceipts(state) {
    return state.specialOfferReceipts
  },
  total(state) {
    return state.total
  },
  isSpecialOfferReceiptLoading(
    state,
  ): SpecialOfferReceiptState['isSpecialOfferReceiptLoading'] {
    return state.isSpecialOfferReceiptLoading
  },
  nextReceiptId(state) {
    const currentId = state.specialOfferReceipt.id
    const nextIndex =
      state.specialOfferReceipts.findIndex(
        receipt => receipt.id === currentId,
      ) + 1
    if (nextIndex === -1) {
      return null
    }
    if (
      nextIndex === state.specialOfferReceipts.length ||
      nextIndex > state.specialOfferReceipts.length
    ) {
      return null
    }
    return state.specialOfferReceipts[nextIndex].id
  },
}
